import request from '../utils/request';

// 登录
export function loginApi(data) {
  return request.post('/auth/login', data);
}

// 注册
export function registerApi(data) {
  return request.post('/auth/register', data);
}

// 发送短信验证码
export function sendSmsCodeApi(data) {
  return request.post('/auth/sendSmsCode', data);
}

// 忘记密码 - 重置密码
export function resetPasswordApi(data) {
  return request.post('/auth/resetPassword', data);
}

// 修改密码（原密码校验）
export function changePasswordApi(data) {
  return request.post('/auth/changePassword', data);
}

// 实名认证
export function verifyIdentityApi(data) {
  return request.post('/auth/verifyIdentity', data);
}

// 上传合同
export function uploadContractApi(formData) {
  return request.post('/auth/uploadContract', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}
